import { render, staticRenderFns } from "./resources-table.vue?vue&type=template&id=72879c77&"
import script from "./resources-table.vue?vue&type=script&lang=js&"
export * from "./resources-table.vue?vue&type=script&lang=js&"
import style0 from "./resources-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports